import React, { useState } from "react";
import "./stiluri/MeniuLateral.css";
import GeneralView from "./imagini/LogoGeneralView.png";
import ProfilBeneficiar from "./imagini/ProfilBeneficiarLogo.png";
import DosarLogo from "./imagini/DosarLogo.png";
import MonitorizareLogo from "./imagini/MonitorizareLogo.png";
import ReintegrareLogo from "./imagini/Reintegrare.png";
import AddLogo from "./imagini/add.png";

const MeniuLateral = ({ onSectiuneSelectata }) => {
  // Starea pentru a controla deschiderea fiecărei categorii
  const [DosarOpen, setDosarOpen] = useState(false);
  const [DatePersonaleOpen, setDatePersonaleOpen] = useState(false); // Noua stare pentru "Date Personale"

  // Funcții pentru a toggle (schimba) starea categoriilor
  const toggleDosar = () => setDosarOpen(!DosarOpen);
  const toggleDatePersonale = () => setDatePersonaleOpen(!DatePersonaleOpen); // Funcție pentru "Date Personale"

  // Modificăm funcțiile de click pentru a trimite sectiunea selectată
  const handleClickSectiune = (sectiune) => {
    onSectiuneSelectata(sectiune); // Actualizăm sectiunea selectată
  };

  return (
    <nav className="meniu-lateral">
      <li onClick={() => handleClickSectiune("Actiuni")}>
          <img
            src={AddLogo}
            alt="AddLogo"
            style={{ width: "20px", marginRight: "5px", marginBottom: "5px", marginLeft: "0px" }}
          />
          Adaugă o acțiune
        </li>
      <h3>Dosar Personal</h3>
      <ul>
        <li onClick={() => handleClickSectiune("privireGenerala")}>
          <img
            src={GeneralView}
            alt="GeneralView"
            style={{ width: "20px", marginRight: "4px", marginBottom: "5px" }}
          />
          Privire Generală
        </li>

        <li onClick={toggleDatePersonale}>
          <img
            src={ProfilBeneficiar}
            alt="ProfilBeneficiar"
            style={{ width: "15px", marginRight: "9px", marginBottom: "5px" }}
          />
          Profil Beneficiar
          {/* Submeniul pentru "Date Personale" se va afişa doar dacă starea este true */}
          {DatePersonaleOpen && (
            <ul>
              <li onClick={() => handleClickSectiune("datePersonale")}>
                Date Personale
              </li>
              <li onClick={() => handleClickSectiune("albumfoto")}>
                Galerie Foto
              </li>
              <li onClick={() => handleClickSectiune("contact")}>
                Date de Contact
              </li>
            </ul>
          )}
        </li>

        <li onClick={toggleDosar}>
          <img
            src={DosarLogo}
            alt="DosarLogo"
            style={{ width: "15px", marginRight: "9px", marginBottom: "5px" }}
          />
          Dosar Digital
          {DosarOpen && (
            <ul>
              <li onClick={() => handleClickSectiune("dosarSocial")}>
                Dosar Social
              </li>
              <li onClick={() => handleClickSectiune("dosarPsihologic")}>
                Dosar Psihologic
              </li>
              <li onClick={() => handleClickSectiune("dosarAngajari")}>
                Dosar Angajări
              </li>
              <li onClick={() => handleClickSectiune("dosarFinanciar")}>
                Dosar Financiar
              </li>
              <li onClick={() => handleClickSectiune("dosarJuridic")}>
                Dosar Juridic
              </li>
              <li onClick={() => handleClickSectiune("dosarMedical")}>
                Dosar Medical
              </li>
            </ul>
          )}
        </li>

       


      </ul>
               
         <li onClick={() => handleClickSectiune("IstoricActiuni")}>
          <img
            src={MonitorizareLogo}
            alt="MonitorizareLogo"
            style={{ width: "18px", marginRight: "6px", marginBottom: "5px" }}
          />
          Istoric Acțiuni
        </li>
                <li onClick={() => handleClickSectiune("Reintegrare")}>
          <img
            src={ReintegrareLogo}
            alt="ReintegrareLogo"
            style={{ width: "21px", marginRight: "6px", marginBottom: "5px" }}
          />
          Social AI
        </li>
    </nav>
  );
};

export default MeniuLateral;
